import axios from 'axios'

const fetchBotTemplates = async filter => {
  const url = `/api/v1/botTemplates${filter ? filter : ''}`
  return await axios.get(url)
}

const deleteBotTemplate = async templateHexId => {
  return await axios.delete(`/api/v1/botTemplates/${templateHexId}`)
}

export default {
  fetchBotTemplates,
  deleteBotTemplate
}
